import { css } from "@linaria/core";
import cx from "classnames";
import React, { memo, useMemo } from "react";
import { Link } from "react-router-dom";
import Text from "@ui/Text";
import { colors } from "@ui/Theme";
import type { DashboardModelT } from "../../schema/dashboard";
// import { DashboardMenu } from "../DashboardMenu";
import { useDashboardEditorContext } from "../../hook/context/editor";
import { useDashboardEditorState } from "../../hook/store/editor";
import Ellipsis from "@ui/Ellipsis";
import { LockLine } from "@ui/IconV2/react";
import { toPath } from "../../../../../router/helpers/path";

const fullWidthElement = css`
  width: 100%;
`;

const container = css`
  align-items: center;
  background-color: transparent;
  min-height: 36px;
  border-radius: 4px;
  color: ${colors.carbon800};
  display: flex;
  gap: 8px;
  justify-content: space-between;
  padding: 0 8px;
  transition: background-color 150ms ease-in-out;

  & + li {
    margin-top: 8px;
  }

  &:has(a:is(:hover, .selected)) {
    background-color: ${colors.titanium100};
  }
`;

const itemLink = css`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;

  &::before,
  span {
    grid-column: 1 / -2;
    grid-row: 1 / -1;
    transition-property: opacity, transform;
    transition-duration: 150ms;
    transition-timing-function: ease-out;
  }

  &::before {
    content: attr(data-text);
    font-weight: normal;
    transform-origin: left center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  span,
  :is(:hover, .selected)::before {
    opacity: 0;
  }

  :not(:is(:hover, .selected))::before,
  :is(:hover, .selected) span {
    transition-delay: 25ms;
  }

  :is(:hover, .selected)::before {
    transform: scaleX(1.01);
  }

  :is(:hover, .selected) span {
    opacity: 1;
  }
`;

export const DashboardListItem = memo(
  ({ dashboard, selected }: { dashboard: DashboardModelT; selected: boolean }) => {
    const editor = useDashboardEditorContext();
    const editorState = useDashboardEditorState(editor?.store);

    /**
     * @note Switching from dashboard to editor IndexedDB state from edit mode.
     */
    const title = useMemo(
      () =>
        editorState?.dashboard?.id === dashboard.id
          ? editorState?.dashboard.title
          : dashboard.title,
      [dashboard, editorState?.dashboard],
    );

    // const route = useRoute();
    // const showMenu = useMemo(
    //   () =>
    //     route?.key === "dashboard" &&
    //     (route?.edit === false || (route?.edit === true && route?.dashboardId !== dashboard.id)),
    //   [dashboard.id, route],
    // );
    // const showMenuPrintOption = useMemo(
    //   () => route?.key === "dashboard" && !route?.edit && route?.dashboardId === dashboard.id,
    //   [route, dashboard.id],
    // );

    return (
      <li className={container}>
        <Text type="body1SemiBold" className={fullWidthElement}>
          <Link
            to={toPath("/projects/:projectId/dashboards/:dashboardId", {
              projectId: dashboard.projectId,
              dashboardId: dashboard.id,
            })}
            className={cx(fullWidthElement, itemLink, {
              selected,
            })}
            data-text={title}
          >
            <Ellipsis>{title}</Ellipsis>
            {dashboard.readonly && <LockLine />}
          </Link>
        </Text>
        {/* {showMenu && <DashboardMenu dashboard={dashboard} withPrintOption={showMenuPrintOption} />} */}
      </li>
    );
  },
);
